import { styles } from "./MainSection";

export const AboutSection = () => (
  <section id="about" className="about">
    <div className="container" data-aos="fade-up">
      <div className="section-header">
        <h2>About Us</h2>
        <p>
          Learn More <span>About Us</span>
        </p>
      </div>

      <div className="row gy-4">
        <div
          className="col-lg-7 position-relative about-img"
          style={styles.aboutBG}
          data-aos="fade-up"
          data-aos-delay="150"
        >
          {/* <h2>Interested in booking 7 Starr Wings for your event?</h2> */}
          <a href="tel:+12678881206">
            <div className="call-us position-absolute">
              <h4>Reservations</h4>
              <p>267.888.1206</p>
            </div>
          </a>
        </div>
        <div
          className="col-lg-5 d-flex align-items-end"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div className="content ps-0 ps-lg-5">
            <p className="fst-italic">
              We provide classic fusion of American cuisine, southern comfort
              food, Caribbean spice, and European zest right to your door.
            </p>
            {/* <ul>
<li><i className="bi bi-check2-all"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
<li><i className="bi bi-check2-all"></i> Duis aute irure dolor in reprehenderit in voluptate velit.</li>
<li><i className="bi bi-check2-all"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</li>
</ul>
<p>
Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident
</p> */}

            <div className="position-relative mt-4">
              <a
                href="https://www.youtube.com/watch?v=LXb3EKWsInQ"
                className="glightbox play-btn"
              >
                <img src="/img/about-2.jpg" className="img-fluid" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
